import { FormStore, GlobalStore } from '@roc/feature-app-core';
import { action, observable, flow, makeObservable } from 'mobx';
import { ExternalAgentLoanService } from '../services/externalAgentLoanService';
import { VendorBankInformationStore } from './vendorBankInformationStore';

const profileBankInformationfields = {
  fields: {
    beneficiaryBankName: {
      value: '',
      error: null,
      rule: '',
    },
    beneficiaryRoutingNumber: {
      value: '',
      error: null,
      rule: '',
    },
    beneficiaryAccountName: {
      value: '',
      error: null,
      rule: '',
    },
    beneficiaryAccountNumber: {
      value: '',
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class VendorCompanyProfileStore {
  private globalStore: GlobalStore;
  selectedTabIndex = 0;
  companyInformation: any;
  service: ExternalAgentLoanService;
  vendorBankInformationStore: VendorBankInformationStore;
  profileBankInformationFormStore: FormStore;

  constructor(globalStore) {
    this.globalStore = globalStore;
    this.service = new ExternalAgentLoanService();
    this.vendorBankInformationStore = new VendorBankInformationStore(globalStore, this)
    this.profileBankInformationFormStore = new FormStore(profileBankInformationfields, globalStore);
    makeObservable(this, {
      selectedTabIndex: observable,
      profileBankInformationFormStore: observable,
      setSelectedTabIndex: action,
      getCompanyInformation: flow,
      companyInformation: observable,
    });
  }

  setSelectedTabIndex(selectedTabIndex) {
    this.selectedTabIndex = selectedTabIndex;
  }

  getIndexFromTab(tabs, selectedTab) {
    if (selectedTab === 'b') {
      selectedTab = 'BANK INFORMATION';
      const tab = tabs.findIndex(tab => tab.label === selectedTab);
      this.setSelectedTabIndex(tab);
    }
  }

  *getCompanyInformation(companyId: number) {
    try {
      const response = yield this.service.getCompanyInformation(companyId);
      this.companyInformation = JSON.parse(response.data.data);
      console.log("company", this.companyInformation);
      this.profileBankInformationFormStore.loadForm(this.companyInformation?.bankDetails);
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while loading vendor company information',
      });
    }
  }
}
